/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';
import React from 'react';

import { SnackbarNotification } from '../../components/SnackbarNotification/SnackbarNotification';
import { getCommonEventKey } from '../../constants/notificationsKeys';
import { AppStandaloneEvents } from '../../types/common/AppEvents';
import { getRandomId } from '../../utils/getRandomId';
import { INotification } from '../notifications/types';
import { NotifierActions } from './types';

export const enqueueSnackbar = (message: SnackbarMessage, options?: OptionsObject, dismissed?: boolean) => {
  const key = options && options.key;

  return {
    type: NotifierActions.ENQUEUE_SNACKBAR,
    notification: {
      message,
      options,
      dismissed,
      key: key || getRandomId(new Date().getTime() + Math.random()),
    },
  };
};

export const enqueueHUSnackbarByEvent = (item: INotification, options: OptionsObject = {}, dismissed?: boolean) => {
  const snackbarKey = options.key || getRandomId(item.id);

  return enqueueSnackbar(
    React.createElement(SnackbarNotification, {
      item,
      snackbarKey,
      variant: options?.variant,
    }),
    {
      ...options,
      key: snackbarKey,
      content: (key, message) => message,
    },
    dismissed,
  );
};

export const enqueueHUSnackbar = (
  {
    secondaryText,
    primaryText,
  }: {
    primaryText: string | React.ReactNode;
    secondaryText?: string | React.ReactNode;
  },
  options?: OptionsObject,
) => {
  return enqueueHUSnackbarByEvent(
    {
      createdAt: new Date(),
      id: getCommonEventKey(),
      type: AppStandaloneEvents.TextToastr,
      event: {
        secondaryText,
        primaryText,
      },
    } as INotification<AppStandaloneEvents.TextToastr>,
    options,
  );
};

export const closeSnackbar = (key: SnackbarKey) => ({
  type: NotifierActions.CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
});

export const removeSnackbar = (key: SnackbarKey) => ({
  type: NotifierActions.REMOVE_SNACKBAR,
  key,
});
